import { render, staticRenderFns } from "./vEnabledClaimsList.vue?vue&type=template&id=2ed92422&scoped=true"
import script from "./vEnabledClaimsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./vEnabledClaimsList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vEnabledClaimsList.vue?vue&type=style&index=0&id=2ed92422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed92422",
  null
  
)

export default component.exports